/* ============================================
   DataFusion – localStorage Cart System
   ============================================ */
var DFCart = (function(){
  var STORAGE_KEY = 'df_cart';

  function getItems() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch(e) { return []; }
  }

  function save(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    updateBadge();
    window.dispatchEvent(new Event('df:cart:updated'));
  }

  function addItem(item) {
    var items = getItems();
    var existing = null;
    for (var i = 0; i < items.length; i++) {
      if (items[i].id === item.id && items[i].color === item.color && items[i].size === item.size && items[i].estampado === item.estampado) {
        existing = i;
        break;
      }
    }
    if (existing !== null) {
      items[existing].qty += item.qty;
    } else {
      items.push(item);
    }
    save(items);
    return items;
  }

  function removeItem(index) {
    var items = getItems();
    items.splice(index, 1);
    save(items);
    return items;
  }

  function updateQty(index, qty) {
    var items = getItems();
    if (qty <= 0) {
      items.splice(index, 1);
    } else {
      items[index].qty = qty;
    }
    save(items);
    return items;
  }

  function clearCart() {
    save([]);
  }

  function getCount() {
    var items = getItems();
    var total = 0;
    for (var i = 0; i < items.length; i++) total += items[i].qty;
    return total;
  }

  function getTotal() {
    var items = getItems();
    var total = 0;
    for (var i = 0; i < items.length; i++) total += items[i].price * items[i].qty;
    return total;
  }

  function updateBadge() {
    var count = getCount();
    var badges = document.querySelectorAll('.df-header__cart-count');
    badges.forEach(function(el){
      if (count > 0) {
        el.textContent = count;
        el.style.display = '';
      } else {
        el.style.display = 'none';
      }
    });
  }

  function buildWhatsAppMsg() {
    var items = getItems();
    if (!items.length) return '';
    var msg = '🛒 *Mi Pedido - Data Fusion*\n';
    msg += '━━━━━━━━━━━━━━━━━━━━\n\n';
    var total = 0;
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      var lineTotal = it.price * it.qty;
      total += lineTotal;
      msg += '▸ *' + it.name + '*\n';
      msg += '  Color: ' + it.color + ' | Talla: ' + it.size + (it.estampado ? ' | Estampado: ' + it.estampado : '') + '\n';
      msg += '  Cant: ' + it.qty + ' × $' + it.price + ' = *$' + lineTotal + '*\n';
      if (it.notas) msg += '  Notas: ' + it.notas + '\n';
      msg += '\n';
    }
    var discount = 0;
    for (var j = 0; j < items.length; j++) {
      if (items[j].qty >= 6 && items[j].name === 'Camiseta de Algodón') discount += items[j].qty * 2;
    }
    msg += '━━━━━━━━━━━━━━━━━━━━\n';
    if (discount > 0) {
      msg += '🏷️ *DESCUENTO (6+ uds): -$' + discount + '*\n';
      msg += '💰 *TOTAL ESTIMADO: $' + (total - discount) + '*\n\n';
    } else {
      msg += '💰 *TOTAL ESTIMADO: $' + total + '*\n\n';
    }
    msg += '📍 _Por favor confirmar disponibilidad y forma de pago._';
    return msg;
  }

  document.addEventListener('DOMContentLoaded', updateBadge);

  return {
    getItems: getItems,
    addItem: addItem,
    removeItem: removeItem,
    updateQty: updateQty,
    clearCart: clearCart,
    getCount: getCount,
    getTotal: getTotal,
    updateBadge: updateBadge,
    buildWhatsAppMsg: buildWhatsAppMsg
  };
})();
